var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferLetterHorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49842 20H1.16666V8H6.49842M6.49842 20L17.1667 26V2L6.49842 8M6.49842 20V8",
    stroke: "#0050C9",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4869 16.0085C22.9245 15.4299 23.1615 14.7244 23.1617 13.9989C23.162 13.2735 22.9256 12.5679 22.4884 11.9889M26.2084 18.8247C27.2585 17.436 27.8271 15.7428 27.8276 14.0017C27.8283 12.2608 27.2609 10.5671 26.2117 9.17773",
    stroke: "#0050C9",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferLetterHorn);
export default __webpack_public_path__ + "static/media/offer-letter-horn.a7b960bde2be0df322145941a7c7e60e.svg";
export { ForwardRef as ReactComponent };